export default __webpack_public_path__ + "static/media/Opera-logo.8751e435.png";